import apiFetch from '../apiFetch'

export default function (data, endpoint="printronix") {
  return apiFetch({
    server: 'printronixRFID', endPoint: endpoint, method: 'POST', body: data, token: null,
    mode: 'cors', credentials: 'omit'
  })
}
